import { DeleteOutlined } from '@ant-design/icons';
import { useField } from '@framework/form/field/useField.tsx';
import { TextAreaInput } from '@framework/form/inputs/TextAreaInput.tsx';
import { Button, Popconfirm, Space } from 'antd';

export interface ICustomValidationRuleContentProps {
  name: string;
  setVisible: (visible: boolean) => void;
}

/**
 * Contenuto del popover per impostare il messaggio personalizzato per le regole di validazione
 */
export function CustomValidationRuleContent(
  props: ICustomValidationRuleContentProps,
) {
  const { name, setVisible } = props;
  const { setValue } = useField(name);

  return (
    <div>
      <span>
        <TextAreaInput style={{ width: '500px' }} rows={4} name={name} />
      </span>
      <span
        style={{
          marginTop: '8px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Space>
          <Popconfirm
            title={
              'Sei sicuro di voler eliminare il messaggio di errore personalizzato?'
            }
            placement="topRight"
            okButtonProps={{ danger: true }}
            okText="Elimina"
            onConfirm={() => {
              setValue('');
              setVisible(false);
            }}
          >
            <Button type="primary" danger size="small">
              <DeleteOutlined /> Elimina
            </Button>
          </Popconfirm>
          <Button
            type="primary"
            size="small"
            onClick={() => {
              setVisible(false);
            }}
          >
            Applica
          </Button>
        </Space>
      </span>
    </div>
  );
}
